import { usePricingConfig } from 'hooks/billing/usePricingConfig';
import { useQuota } from 'hooks/billing/useQuota';
import { ALERT_TYPES } from 'types/billing';
import { deriveAlert } from 'utils/billing/deriveAlert';

/**
 * True when the paid pool is in the percentage-threshold "approaching limit"
 * band (the red "act now" treatment shared by the hero + sidebar widget).
 * Centralizes the derivation so the page hero and the sidebar widget can't
 * drift apart.
 */
export const useIsApproaching = (): boolean => {
  const { data: quota } = useQuota();
  const cfg = usePricingConfig();

  return (
    quota != null &&
    deriveAlert(quota, cfg)?.type === ALERT_TYPES.percentageThreshold
  );
};
